import styled from "styled-components";

export const Search = styled.input`
    font-family: 'Lexend Deca';
    font-style: normal;
    font-weight: 400;
    font-size: 1.2rem;
    line-height: 2rem;
    color: #929292;
    background-color: #FFF;
    border: none;
    outline: none;
    padding: .5rem 1.5rem;
    border-radius: .4rem 0 0 .4rem;
`